import script from "./ChatSidebarSearch.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatSidebarSearch.vue?vue&type=script&setup=true&lang=js"

import "./ChatSidebarSearch.vue?vue&type=style&index=0&id=42cc5c53&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42cc5c53"]])

export default __exports__